var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard48 = function SvgCreditCard48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#65C1B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Credit_Card_48_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Credit_Card_48_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: -6,
    y: 28.8,
    width: 28.8,
    height: 28.8,
    rx: 1.667,
    stroke: "#000",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40.8,
    cy: 8.4,
    r: 14.4,
    stroke: "#000",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 10.8,
    y: 14.4,
    width: 28.8,
    height: 22.8,
    rx: 3,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4,
    y: 12,
    width: 28.8,
    height: 22.8,
    rx: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.8h21.6H12Z",
    fill: "#3EB2A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.8h21.6",
    stroke: "#3EB2A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 18.6,
    cy: 28.2,
    r: 3,
    fill: "#3EB2A2"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 13.8,
    cy: 28.2,
    r: 3,
    fill: "#3EB2A2"
  }))));
};
export default SvgCreditCard48;